import { createSlice } from "@reduxjs/toolkit";

export const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    calendarList: [],
    pending: false,
    error: false,
  },
  reducers: {
    processEventStart: (state) => {
      state.pending = true;
      state.error = false;
    },
    addEventSuccess: (state, action) => {
      const found = state.calendarList.some((el) => el.id === action.payload.id);
      if (!found) {
        state.calendarList.push(action.payload);
        state.calendarList.sort((a,b) => (a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0))
      }
      state.pending = false;
    },
    removeEventSuccess: (state, action) => {
      const index = state.calendarList.findIndex((item) => item.id === action.payload);
      state.calendarList.splice(index, 1);
      state.pending = false;
    },
    processEventError: (state) => {
      state.pending = false;
      state.error = true;
    },
    loadEventSuccess: (state, action) => {
      state.calendarList = action.payload;
      state.pending = false;
    },
  },
});

export const {
  addEventSuccess,
  removeEventSuccess,
  processEventStart,
  processEventError,
  loadEventSuccess,
} = calendarSlice.actions;

export default calendarSlice.reducer;
